import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { FiltersGrid } from '../types';
import { MeteringPointActTypeFlat } from './types';

export const meteringPointActTypesApi = createApi({
  reducerPath: 'meteringPointActTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-point-act-types`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringPointActTypes: builder.query<
      MeteringPointActTypeFlat[],
      FiltersGrid | void
    >({
      query: params => ({
        url: '/query',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetMeteringPointActTypesQuery } = meteringPointActTypesApi;
